import { gql } from "@apollo/client";

const DELETE_OUNIT = gql`
  mutation deleteOUnit($ounit_id: String!) {
    deleteOUnit(ounit_id: $ounit_id) 
  }
`;

export default DELETE_OUNIT;
